export default __webpack_public_path__ + "static/media/chatApp.df751045.png";